(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('AiAssistantSystemCommandsController', AiAssistantSystemCommandsController);

    AiAssistantSystemCommandsController.$inject = ['AiAssistantMonitoring', 'AlertService'];

    function AiAssistantSystemCommandsController(AiAssistantMonitoring, AlertService) {
        var vm = this;

        vm.loading = false;
        vm.catalog = {
            generatedAt: null,
            commands: []
        };

        activate();

        function activate() {
            vm.loading = true;
            AiAssistantMonitoring.getSystemCommands().then(function(response) {
                vm.catalog = response.data || vm.catalog;
            }).catch(function(error) {
                AlertService.error(error && error.data && error.data.message
                    ? error.data.message
                    : 'Impossible de charger les commandes systeme de l\'assistant IA.');
            }).finally(function() {
                vm.loading = false;
            });
        }
    }
})();
